import { createContext, useContext, type MutableRefObject } from "react"

export type SearchStatus = "idle" | "below-min" | "ready"

export type SelectorContextValue = {
  isLoading: boolean
  setIsLoading(isLoading: boolean): void
  shouldFilter: boolean
  portal: boolean
  searchStatus: SearchStatus
  setSearchStatus(status: SearchStatus): void
  minSearchLengthRef: MutableRefObject<number>
}

const SelectorContext = createContext<SelectorContextValue | null>(null)

export function useSelectorContext() {
  const ctx = useContext(SelectorContext)
  if (!ctx) {
    throw new Error("Selector compound components must be used within Selector")
  }
  return ctx
}

export default SelectorContext
